import React, { useState, useEffect, useCallback } from "react";
import Button from "react-bootstrap/Button";
import PageTitle from "../../layouts/PageTitle";
import DiscountModal from "./DiscountModal";
import DiscountHistory from "./DiscountHistory";
import axios from "axios";
import {
  addUserSingleTicketResponse,
  getSingleUserData,
  getAllDiscountApplications,
} from "../../../services/adminApiService/grievanceTicket/grievanceTicketApis";
import PaginationComp from "../../../common/ui/view/pagination/PaginationComp";
import ViewTicket from "../../../admin/admincomponent/ticket/ViewTicket";
import moment from "moment";

// const allowedCharsRegex = /^[a-zA-Z0-9?()&'\-,.\s]*$/;
const allowedCharsRegex = /^.*$/;

//colors
const getStatusColor = (status) => {
  switch (status) {
    case "In_Progress":
      return "#FFA500"; // Orange
    case "Resolved":
      return "#4CAF50"; // Green
    case "Closed":
      return "#808080"; // Gray
    case "Reopened":
      return "#FF4500"; // Dark Orange/Red
    case "New":
      return "#FF8C00"; // Dark Orange/ Dark Orange/Red
    default:
      return "#000000"; // Black as fallback
  }
};

// file extension check regex
export const formatOFTicketRegex = /.(jpe?g|png)$/i;

export function ApplyForDiscount() {
  const [showTicketModal, setshowTicketModal] = React.useState(false);
  const handleShowTicketModal = () => {
    setReapplyDisable(false);
    setshowTicketModal(true);
  };
  const handleCloseTicketModal = () => setshowTicketModal(false);
  const [currentpage, setCurrentPage] = React.useState(1);
  const [totalPages, setTotalPages] = React.useState(null);
  const [uploadedFile, setUploadedFile] = React.useState(null);
  const [data, setData] = React.useState({});
  const [viewTicketData, setviewTicketData] = React.useState({});
  const [responseText, setResponseText] = React.useState("");
  const [isLoading, setisLoading] = React.useState(false);
  const [error, setError] = useState({});
  const [show, setshow] = React.useState(false);
  const [selectedTickedDeatils, setselectedTickedDeatils] = React.useState({});
  const [currentChatId, setcurrentChatId] = React.useState(null);
  const selectedTicketRef = React.useRef(null);
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [reapplyDisable, setReapplyDisable] = useState(false);
  const [playerTypeReApply, setPlayerTypeReApply] = useState("");
  const [reApplyId, setReApplyId] = useState("");
  const [medalReApply, setMedalReApply] = useState("");
  const [remarkReApply, setRemarkReApply] = useState("");

  const BASE_URL = process.env.REACT_APP_BOOKING_BASE_URL;
  const TOKEN =
    localStorage.getItem("access_token") ||
    localStorage.getItem("access_token_admin");
  // your JWT token

  const handleCloseChat = () => setviewTicketData({});

  const handleViewTicket = useCallback(async (application_id, item) => {
    setshow(true);
    setselectedTickedDeatils(item);
    try {
      const res = await axios.get(
        `${BASE_URL}/api/auth/discount/users/track_application/${application_id}`,
        {
          headers: {
            Authorization: TOKEN,
            Accept: "application/json",
          },
        }
      );
      if (res?.data?.statusCode === 200) {
        setviewTicketData(res.data);
      } else {
        setviewTicketData(null);
      }
    } catch (err) {
      console.error("Error fetching application details:", err);
      setviewTicketData(null);
    }
  }, []);

  const handleResponseText = (e) => {
    let { name, value } = e.target;
    value = value.trimStart();
    setResponseText(value);
    if (!allowedCharsRegex.test(value)) {
      setError({
        ...error,
        [name]:
          "Invalid characters detected. Only ? ( ) - ' & . , are allowed.",
      });
    } else {
      setError("");
    }
  };

  const handleSubmitResponse = async (id) => {
    if (!responseText && !uploadedFile) return;
    if (Object.keys(error).length > 0) return;

    let formData = new FormData();
    formData.append("description", responseText);
    formData.append("id", id);
    uploadedFile && formData.append("attachement", uploadedFile);
    setisLoading(true);
    try {
      let res = await addUserSingleTicketResponse(formData);
      if (res?.data?.status) {
        await handleViewTicket("_", selectedTicketRef.current);
        setResponseText("");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setisLoading(false);
    }
  };
  const getAllDiscountApplications = async (payload = {}) => {
    const { page = 1, limit = itemsPerPage, player_type, status } = payload;
    let url = `${BASE_URL}/api/auth/discount/users/applications?page=${page}&limit=${limit}`;
    if (player_type) url += `&player_type=${player_type}`;
    if (status) url += `&status=${status}`;

    try {
      setLoading(true);
      const response = await axios.get(url, {
        headers: {
          Authorization: TOKEN,
          Accept: "application/json",
        },
      });

      fetch(
        "https://staging-booking-api.jharkhandsports.in/api/auth/discount/users/applications?page=1",
        {
          headers: {
            Authorization:
              localStorage.getItem("access_token") ||
              localStorage.getItem("access_token_admin"),
          },
        }
      )
        .then((res) => res.json())
        .then(console.log);

      // Assuming response looks like { data: { applications: [], totalPages: 5 } }
      setData(response?.data || {});
      setTotalPages(response?.data?.totalPages || 1);
    } catch (error) {
      console.error("Error fetching discount applications:", error);
    } finally {
      setLoading(false);
    }
  };

  function handleReApply(playerType, medal, id, remark) {
    setPlayerTypeReApply(playerType);
    setMedalReApply(medal);
    setReApplyId(id);
    setRemarkReApply(remark)
    setshowTicketModal(true);
    setshow(false);
    setReapplyDisable(true);
  }

  useEffect(() => {
    getAllDiscountApplications({ page: currentpage, limit: itemsPerPage });
  }, [currentpage, itemsPerPage]);

  const handleClose = () => {
    setshow(false);
    setReapplyDisable((prev) => !prev);
  };

  return (
    <>
      <style>
        {`
        /* --- STATUS BADGES --- */
.status-badge {
  display: inline-block;
  font-size: 13px;
  font-weight: 500;
  border-radius: 50px;
  padding: 4px 12px;
  text-transform: capitalize;
}

.status-badge.pending {
  background-color: #fff3e0;
  color: #ff9800;
}

.status-badge.reapply {
  background-color: #fff0cc;
  color: #e6a100;
}

.status-badge.rejected {
  background-color: #ffe5e5;
  color: #ff4d4d;
}

.status-badge.approved {
  background-color: #e6f4ea;
  color: #4caf50;
}

.status-badge.default {
  background-color: #f0f0f0;
  color: #757575;
}

/* --- VIEW BUTTON --- */
.view-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  font-weight: 500;
  background-color: #f2f2f2;
  border: none;
  border-radius: 8px;
  padding: 6px 14px;
  color: #333;
  cursor: pointer;
  transition: all 0.2s ease;
}

.view-btn:hover {
  background-color: #e0e0e0;
}

.view-btn i {
  font-size: 14px;
  color: #333;
}

      `}
      </style>
      <PageTitle
        activeMenu="Apply For Discount"
        motherMenu="Home"
        Button={() => (
          <Button onClick={handleShowTicketModal}>Apply For Discount</Button>
        )}
      />
      <div className="col-12">
        <div className="card">
          <div className="card-body">
            <div className="w-100 table-responsive">
              <div className="mb-4">
                <h3 className="text-dark mb-3">Info</h3>
                <ul className="list-unstyled ps-3 text-muted">
                  <li className="mb-2">
                    • For National and International Medalist players, no fee
                    for their particular sport.
                  </li>
                  <li className="mb-2">
                    • State-level medalist players up to the age of 20 years
                    will receive a 75% fee relaxation.
                  </li>
                  <li className="mb-2">
                    • Participants must be at least 12 years old to register for
                    swimming. For all other sports, the minimum age requirement
                    is 8 years.
                  </li>
                </ul>
              </div>

              <div id="example_wrapper" className="dataTables_wrapper">
                <table id="example" className="display w-100 dataTable">
                  <thead>
                    <tr>
                      <th>Application ID</th>
                      <th>Sport</th>
                      <th>Medal</th>
                      <th>Applied Date</th>
                      <th>Player Type</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.applications?.length > 0 ? (
                      data.applications.map((item) => {
                        const status =
                          item.application_status?.toLowerCase() || "";
                        let badgeClass = "";
                        let badgeText = "";

                        switch (status) {
                          case "pending":
                            badgeClass = "status-badge pending";
                            badgeText = "Pending";
                            break;
                          case "reapply":
                          case "re_apply":
                            badgeClass = "status-badge reapply";
                            badgeText = "Re Apply";
                            break;
                          case "rejected":
                            badgeClass = "status-badge rejected";
                            badgeText = "Rejected";
                            break;
                          case "approved":
                            badgeClass = "status-badge approved";
                            badgeText = "Approved";
                            break;
                          default:
                            badgeClass = "status-badge default";
                            badgeText =
                              status.charAt(0).toUpperCase() +
                                status.slice(1) || "-";
                        }

                        return (
                          <tr key={item.application_id}>
                            <td>{item.application_id}</td>
                            <td>{item.sport_name || "-"}</td>
                            <td>{item.medal_type || "-"}</td>
                            <td>
                              {moment(item.applied_date).format("DD MMM, YYYY")}
                            </td>
                            <td>{item.applied_for || "-"}</td>
                            <td>
                              <span className={badgeClass}>{badgeText}</span>
                            </td>
                            <td>
                              <button
                                className="view-btn"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleViewTicket(item.application_id, item);
                                }}
                              >
                                <i className="bi bi-eye me-2"></i> View
                              </button>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="8" className="text-center text-muted">
                          Data is not available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>

                <div className="d-flex justify-content-between align-items-center py-3 pagination-section">
                  <div className="d-flex align-items-center page-selector">
                    <label
                      htmlFor="currentPage"
                      className="me-2 fw-semibold text-muted"
                    >
                      Page
                    </label>
                    <select
                      id="currentPage"
                      className="page-dropdown"
                      value={currentpage}
                      onChange={(e) => setCurrentPage(Number(e.target.value))}
                    >
                      {Array.from({ length: totalPages }, (_, i) => (
                        <option key={i} value={i + 1}>
                          {i + 1}
                        </option>
                      ))}
                    </select>
                    <span className="ms-2 text-muted">
                      of {totalPages || 1}
                    </span>
                  </div>

                  {/* Pagination buttons */}
                  <PaginationComp
                    size={totalPages}
                    setCurrentPage={setCurrentPage}
                    currentpage={currentpage}
                    gutter={true}
                    variant={""}
                    bg={true}
                    circle={true}
                  />
                  <div></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-12">
        <div className="card">
          {show && (
            <DiscountHistory
              show={show}
              setshow={setshow}
              handleClose={handleClose}
              handleReApply={handleReApply}
              selectedApplication={selectedTickedDeatils}
            />
          )}
        </div>
      </div>

      <DiscountModal
        fetchAllTicketData={getAllDiscountApplications}
        showTicketModal={showTicketModal}
        handleCloseTicketModal={handleCloseTicketModal}
        currentpage={currentpage}
        reapplyDisable={reapplyDisable}
        playerTypeReApply={playerTypeReApply}
        medalReApply={medalReApply}
        reApplyId={reApplyId}
        remarkReApply={remarkReApply}
      />
      {/* <DiscountHistory /> */}
    </>
  );
}
